<template>
<div class="advertSwiper" v-if="list.length">
    <el-carousel height="440px">
        <el-carousel-item v-for="(item) in list" :key="item.id">
            <a class="advert" :href="item.link">
                <el-image :src="item.pic.replace('s_', '')" style="height: 100%;width: 100%;object-fit: contain" fit="contain">
                    <div slot="placeholder" class="image-slot">
                        加载中<span class="dot">...</span>
                    </div>
                    <div slot="error" class="el-image__error">
                        <img src="@/assets/imgs/placeholder-logo.png" alt="" style="width:80%;height:80%;object-fit: contain;">
                    </div>
                </el-image>
                <div class="info fontStyle">
                    <div v-html="item.title"></div>
                    <!-- <div>{{item.name}}</div>
                    <div>成交价：{{item.price}}</div> -->
                </div>
            </a>
        </el-carousel-item>
    </el-carousel>
</div>
</template>

<script>
export default {
    name: "advertSwiper",
    props: {
        list: {
            type: Array,
            require: true
        }
    },
    data(){
        return{
            dataList:[
                {id:1,name:'张大千 秋曦图 镜心 设色纸本',lot:'Lot 0297 ',price:'成交价：RMB 195,500,000',pic:"http://img5.artron.net/auction_manager/auction_zone_5/JG0005/x_2021122214554824841.jpg",url:"https://auction.artron.net/paimai-art5193502048/"},
                {id:2,name:'张大千 秋曦图 镜心 设色纸本',lot:'Lot 0288 ',price:'成交价：RMB 195,500,000',pic:"http://img5.artron.net/auction_manager/auction_zone_5/JG0005/x_2021122214554824841.jpg",url:"https://auction.artron.net/paimai-art5193502048/"},
                {id:3,name:'张大千 秋曦图 镜心 设色纸本',lot:'Lot 0297 ',price:'成交价：RMB 195,500,000',pic:"http://img5.artron.net/auction_manager/auction_zone_5/JG0005/x_2021122214554824841.jpg",url:"https://auction.artron.net/paimai-art5193502048/"},
                {id:4,name:'张大千 秋曦图 镜心 设色纸本',lot:'Lot 0297 ',price:'成交价：RMB 195,500,000',pic:"http://img5.artron.net/auction_manager/auction_zone_5/JG0005/x_2021122214554824841.jpg",url:"https://auction.artron.net/paimai-art5193502048/"},
            ],
        }
    },

}
</script>

<style scoped lang="scss">
.advertSwiper{
    position: relative;
    .advert{
        cursor: pointer;
        .info{
            width: 100%;
            height: 100px;
            position: absolute;
            bottom: 0;
            left: 0;
            z-index: 9;
            background: url(../../../assets/imgs/old/showTxtBg.png) repeat-x;
            &:hover{
                text-decoration: underline;
                text-decoration-color: #ffffff;
            }
        }
        .fontStyle{
            font-weight: normal;
            font-size: 18px;
            font-family: "微软雅黑","黑体";
            color: #fff;
            text-align: left;
            padding: 15px 0 0 20px;
            line-height: 22px;
        }
    }
    /deep/.el-carousel__button{
            width: 12px;
            height: 12px;
            border-radius: 50%;
    }
    /deep/.el-carousel__indicators--horizontal{
        position: absolute;
        bottom: 10px;
        right: 0px;
        left: auto;
        padding-top: 0;
        margin-right: 15px;
        z-index: 10;
        transform:none;
    }

}
</style>